import { Injectable } from '@angular/core';
import { BaseListService } from './base-list.service';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { NotificationsSearchModel } from '../../models/push/notifications-search.model';
import { GlobalComponent } from 'src/app/global-component';
import { NotificationModel } from '../../models/push/notification.model';
import { MyfileApiService } from '../myfile-api.service';
import { SearchResultModel } from '../../models/query/search-result-model';
import { NotificationType } from '../../enums/notification-type-enum';

@Injectable({
  providedIn: 'root'
})
export class NotificationListService extends BaseListService {

  defaultNotificationListState: NotificationsSearchModel = {
    sortColumnDirective: '',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: '',
    sortDirection: 'desc',
    type: undefined,
    searchTerm: undefined,
    isRead: undefined,
  };

  private _resultItems$ = new BehaviorSubject<NotificationModel[]>([]);
  protected override _state: NotificationsSearchModel = { ...this.defaultNotificationListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get createdById$() { return this._state.createdById; }

  set isRead(isRead: boolean|undefined) { this._state.isRead = isRead; }
  set createdById(createdById: any) { this._state.createdById = createdById }
  set type(notificationType: NotificationType | undefined) { this._state.type = notificationType }

  protected _search(): Observable<SearchResultModel<NotificationModel> | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getNotifications(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultNotificationListState };
    this._resultItems$.next(new Array<NotificationModel>());
    this._total$.next(0);
  }
}
